import './support.component.scss'

const navigation = document.querySelector('.support-side')
const content = document.querySelector('.support__content')

function stateToggle(root, attribute, value) {
  const current = root.querySelectorAll(`[${attribute}].is-active`)
  const target = root.querySelector(`[${attribute}="${value}"]`)
  current.forEach((node) => node.classList.remove('is-active'))
  if (target) target.classList.add('is-active')
}

function tabHandler(tabName) {
  stateToggle(navigation, 'data-tab-name', tabName)
  stateToggle(content, 'data-tab-name', tabName)
}

function clickHandler(tabName) {
  if (tabName) {
    tabHandler(tabName)
    const target = content.querySelector(`[data-tab-name="${tabName}"]`)
    if (target){
      const headerHeight =
        parseInt(
          document.documentElement.style.getPropertyValue('--header-height')
        ) || 100
      window.scrollTo({
        top:
          target.getBoundingClientRect().top +
          window.pageYOffset -
          headerHeight,
        behavior: 'smooth'
      })
    }
    window.location.hash = tabName
  }
}

if (navigation && content) {
  navigation.addEventListener('click', (event) => {
    event.preventDefault()
    const el = event.target.closest('[data-tab-name]')
    if(el){
      const { tabName } = el.dataset
      clickHandler(tabName)
    }
  })
  const savedState = window.location.hash.replace('#', '')

  if (savedState.length > 0) {
    tabHandler(savedState)
  } else {
    const tabName = navigation.querySelector('[data-tab-name]')
    if (tabName) tabHandler(tabName.dataset.tabName)
  }
}